import { render, staticRenderFns } from "./BadgeVanilla.vue?vue&type=template&id=4927c789&scoped=true"
import script from "./BadgeVanilla.vue?vue&type=script&lang=js"
export * from "./BadgeVanilla.vue?vue&type=script&lang=js"
import style0 from "./BadgeVanilla.vue?vue&type=style&index=0&id=4927c789&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927c789",
  null
  
)

export default component.exports